// Helper: convert a relative file URL like "/api/files/diyatour/uploads/<id>.jpg"
// to absolute, while leaving full http(s) URLs untouched.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export const resolveImage = (url) => {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) {
    return url;
  }
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};
